import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'entity', method: 'POST', body: body, token: token })
}
